import React, { FC, useEffect, useState } from "react";
import VolumeIcon from "@mui/icons-material/VolumeUp";
import { IconButton } from "@mui/material";
import { classNames } from "repoV2/utils/common/render/classNames";
import styles from "./ClickToUnmuteCta.module.scss";
import { IClickToUnmuteCta } from "./IClickToUnmuteCta";

const ClickToUnmuteCta: FC<IClickToUnmuteCta> = ({ className, onClick }) => {
    const [showText, setShowText] = useState(false);

    useEffect(() => {
        // show click for sound text for 2 seconds on mount
        const handleShowText = () => {
            setShowText(true);

            setTimeout(() => {
                setShowText(false);
            }, 2000);
        };

        handleShowText();
    }, []);

    const handleClick = (e: React.SyntheticEvent) => {
        e.stopPropagation();
        if (onClick) onClick();
    };

    return (
        <div className={className} onClick={handleClick}>
            <div
                className={classNames(styles.root, showText && styles.showText)}
            >
                <span className={styles.text}>Click for sound</span>
                <IconButton>
                    <VolumeIcon />
                </IconButton>
            </div>
        </div>
    );
};

export default ClickToUnmuteCta;
